import { createSlice } from '@reduxjs/toolkit';

const likeFormIdSlice = createSlice({
    name: 'likeFormId',
    initialState: false,
    reducers: {
        setLikeFormId: (state, action) => action.payload,
    },
});

export const { setLikeFormId } = likeFormIdSlice.actions;

export default likeFormIdSlice.reducer;
